import { Moengage } from "../../analytics/moengage";
import { Mixpanel } from "../../analytics/mixpanel";
import configureStore from '../../store/configureStore';

const store = configureStore();

const analyticsVendors = [Mixpanel, Moengage];

export const trackDwebEvent = (eventName, eventData) => {
  const state = JSON.parse(localStorage.getItem("USER_APP_CONFIG"))
  const stateInfo = store.getState();
  let user = stateInfo.user && stateInfo.user.userInfo ? stateInfo.user.userInfo : null;

  if (state && (
    ("event_tracking" in state && state.event_tracking && state.event_tracking.mixpanel_is_enabled_dweb)
    ||
    ("eventTracking" in state && state.eventTracking && state.eventTracking.mixpanel_is_enabled_dweb)
  )
  ) {
    for (let vendor of analyticsVendors) {
      vendor.trackEvent(eventName, eventData, user);
    }
  }
};

export const loginDwebEvent = (user) => {

  const state = JSON.parse(localStorage.getItem("USER_APP_CONFIG"));

  if (state && (
    ("event_tracking" in state && state.event_tracking && state.event_tracking.mixpanel_is_enabled_dweb)
    ||
    ("eventTracking" in state && state.eventTracking && state.eventTracking.mixpanel_is_enabled_dweb)
  )
  ) {
    for (let vendor of analyticsVendors) {
      vendor.userLogin(user);
    }
  }
}

export const logoutDwebEvent = () => {

  const state = JSON.parse(localStorage.getItem("USER_APP_CONFIG"));

  if (state && (
    ("event_tracking" in state && state.event_tracking && state.event_tracking.mixpanel_is_enabled_dweb)
    ||
    ("eventTracking" in state && state.eventTracking && state.eventTracking.mixpanel_is_enabled_dweb)
  )
  ) {
    for (let vendor of analyticsVendors) {
      vendor.userLogout();
    }
  }
}